<template>
  <div>
    <b-row class="mt-2">
      <b-col md="4">
        <b-form-group>
          <b-form-input
            v-model="consultarcirugiamedicaprogramada"
            placeholder="Buscar por nombre o cedula del paciente."
            type="text"
            class="d-inline-block"
          />
        </b-form-group>
      </b-col>
      <b-col
        md="2"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-form-group class="w-100">
          <v-select
            id="establecimiento"
            v-model="consultarestablecimiento"
            placeholder="Buscar por establecimiento."
            :options="establecimientos"
            :reduce="(option) => option.value"
            label="text"
            class="d-inline-block w-100"
          />
        </b-form-group>
      </b-col>
      <!-- Selector de Estado -->
      <b-col
        md="2"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-form-group class="w-100">
          <v-select
            id="estado"
            v-model="estadoCirugiaMedica"
            :options="estados"
            placeholder="Buscar por estado."
            :reduce="(option) => option.value"
            label="text"
            class="d-inline-block w-100"
          />
        </b-form-group>
      </b-col>
      <!-- Selector de Fecha Desde -->
      <b-col md="2">
        <b-form-group class="mb-0">
          <b-form-datepicker
            v-model="fechaDesde"
            placeholder="Desde"
          ></b-form-datepicker>
        </b-form-group>
      </b-col>

      <!-- Selector de Fecha Hasta -->
      <b-col md="2">
        <b-form-group class="mb-0">
          <b-form-datepicker
            v-model="fechaHasta"
            placeholder="Hasta"
          ></b-form-datepicker>
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="4"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-button variant="primary" @click="buscarCirugiasMedicasProgramadas">
          <font-awesome-icon icon="magnifying-glass" style="color: white" />
          <span style="color: white"> buscar</span>
        </b-button>
      </b-col>
    </b-row>
    <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
      <b-card class="principal">
        <b-col cols="12" class="pr-0 pl-0 mt-2">
          <b-table
            v-if="items.length > 0"
            bordered
            striped
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #cell(acciones)="data">
              <div class="d-flex justify-content-end">
                <b-button
                  v-if="data.item.estadoCirugiaMedica === '1'"
                  :disabled="!esFechaHoy(data.item.fechaProgramada)"
                  variant="primary"
                  size="sm"
                  @click="
                    cirugiaMedicaAtencion(data.item.idCirugiaMedicaProgramada)
                  "
                >
                  <i class="fas fa-play" style="color: white"></i>
                </b-button>
                <b-tooltip
                  target="boton-dsp"
                  triggers="hover"
                  placement="auto"
                >
                  Descargar consentimiento informado
                </b-tooltip>
                
                <b-button
                  id = "boton-dsp"
                  v-if="data.item.estadoCirugiaMedica === '1'"
                  :disabled="!pressGenerar"
                  variant="info"
                  size="sm"
                  @click="
                    descargarconsentimiento(data.item.idCirugiaMedicaProgramada)
                  "
                >
                <i class="fas fa-file"></i>
                </b-button>

                <b-button
                  id = "boton-consentimiento"
                  v-if="data.item.estadoCirugiaMedica === '1'"
                  
                  variant="warning"
                  size="sm"
                  @click="
                    consentimientoInformadoCirugia(data.item.idCirugiaMedicaProgramada)
                  "
                >
                  <i class="fas fa-exclamation" style="color: white"></i>
                </b-button>
                <b-button
                  v-if="data.item.estadoCirugiaMedica === '2'"
                  variant="primary"
                  size="sm"
                  title="Procesar"
                  @click="
                    procesoCirugiaMedica(data.item.idCirugiaMedicaProgramada)
                  "
                >
                  <i class="fas fa-spinner" style="color: white"></i>
                </b-button>
                <!-- Botón para editar (Calendario) -->
                <b-button
                  v-if="data.item.estadoCirugiaMedica !== '2'"
                  variant="primary"
                  size="sm"
                  @click="editItem(data.item.idCirugiaMedicaProgramada)"
                >
                  <i class="fas fa-calendar" style="color: white"></i>
                </b-button>
                <b-button
                  variant="danger"
                  size="sm"
                  @click="removeItemid(data.item.idCirugiaMedicaProgramada)"
                >
                  <font-awesome-icon icon="circle-xmark" style="color: white" />
                </b-button>
              </div>
            </template>
            <template #cell(informes)="data">
              <b-button
              v-b-tooltip.hover title="Descargar formulario 005"
              size="sm"
              
                >
                  <i class="fas fa-paperclip" style="color: white"></i>
                </b-button>
            </template>
          </b-table>
          <div v-else class="text-center">
            <p>No se encontraron registros</p>
          </div>
        </b-col>
        <b-modal
          id="modal-editar-fecha"
          @ok="
            actualizarFechaProgramada(
              idCirugiaMedicaProgramada,
              fechaProgramadaSeleccionada
            )
          "
        >
          <template #modal-title>
            <h3 class="modal-title">Agregar Fecha</h3>
          </template>

          <template #default>
            <div class="my-3">
              <label for="fecha-programada">Seleccione la nueva fecha:</label>
              <input
                id="fecha-programada"
                type="datetime-local"
                v-model="fechaProgramadaSeleccionada"
                class="form-control"
              />
            </div>
          </template>

          <template #modal-footer="{ ok, cancel, hide }">
            <b-button variant="secondary" @click="cancel"> Cancelar </b-button>
            <b-button variant="primary" @click="ok"> Actualizar </b-button>
          </template>
        </b-modal>
        <b-modal
          id="modal-cirugia-ejecucion"
          title="Ejecución Cirugia Medica"
          ok-title="Ejecutar"
          cancel-title="Cancelar"
          size="lg"
          @ok="ejecutarCirugiaMedica(idCirugiaMedicaProgramada, fechaEjecucion)"
        >
          <template #modal-title>
            <h3 class="modal-title">Ejecutar Cirugia Medica</h3>
          </template>
          <template #default>
            <div class="my-2">
              <b-row>
                <b-card bg-variant="light" text-variant="black">
                  <b-card-text
                    ><b>Paciente: </b>{{ informacionCirugia.primerNombre }}
                    {{ informacionCirugia.primerApellido }}
                  </b-card-text>
                  <b-card-text
                    ><b>Tipo Cirgía Médica: </b>{{ informacionCirugia.cirugia }}
                  </b-card-text>
                </b-card>
              </b-row>
              <b-row>
                <b-col>
                  <label for="fecha-ejecucion">Fecha Ejecucion:</label>
                  <input
                    id="fecha-ejecucion"
                    type="datetime-local"
                    v-model="fechaEjecucion"
                    class="form-control"
                  />
                </b-col>
              </b-row>
              <div class="mt-4">
                <b-row>
                  <b-col>
                    <h3>Consentimiento de Ingreso</h3>
                  </b-col>
                </b-row>
                <b-row class="mb-3">
                  <b-col md="8" class="mb-2">
                    <label for="imagenologo">Diagnosticos de la Cirguía:</label>
                    <v-select
                      placeholder="Escriba un diagnóstico..."
                      v-model="diagnosticosearch"
                      :options="opsDiagnosticos"
                      label="text"
                      @search="onSearchDiagnosticos"
                      :loading="isLoading"
                      :debounce="300"
                    >
                      <template #no-options>
                        {{ noDiagnosticosMessage() }}
                      </template>
                    </v-select>
                  </b-col>
                  <b-col md="4" class="d-flex align-items-center">
                    <b-button
                      variant="info"
                      size="sm"
                      @click="agregarDiagnostico()"
                      style="cursor: pointer"
                    >
                      <strong
                        ><i
                          class="fas fa-solid fa-plus"
                          style="margin-right: 10px"
                          title="Agregar Diagnóstico"
                        ></i
                      ></strong>
                    </b-button>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <span Style="color:black"
                      ><strong>Tabla de Diagnósticos</strong></span
                    >
                    <b-table
                      v-if="diagnosticos.length > 0"
                      :items="diagnosticos"
                      :fields="fieldsti"
                    >
                      <template #cell(diagnostico)="data">
                        {{ data.item.diagnosticotext }}
                      </template>
                      <template #cell(acciones)="data">
                        <b-button
                          variant="danger"
                          size="sm"
                          @click="removeDiagnostico(data.index)"
                          style="cursor: pointer"
                        >
                          <font-awesome-icon icon="circle-xmark" />
                        </b-button>
                      </template>
                    </b-table>
                    <div v-else class="text-center">
                      <p>No se encontraron registros</p>
                    </div>
                  </b-col>
                </b-row>

                <b-row class="my-3">
                  <b-col cols="12">
                    <!-- Sección de formularios, manteniendo una estructura similar para cada entrada -->
                    <b-form-group
                      label="Duracion estimada intervencion:"
                      label-for="v-durestim"
                      class="mb-3"
                    >
                      <b-form-input
                        id="v-durestim"
                        v-model="durestim"
                        placeholder="Ingrese la duración estimada..."
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      label="Riesgos frecuentes (poco graves):"
                      label-for="v-reisgosFrecuentes"
                      class="mb-3"
                    >
                      <b-form-input
                        id="v-reisgosFrecuentes"
                        v-model="reisgosFrecuentes"
                        placeholder="Escriba los riesgos frecuentes..."
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group>
                      <label
                        >Riesgos poco frecuentes (graves):
                        <span class="text-danger">*</span></label
                      >
                      <b-form-input
                        id="v-reisgosPocoFrecuentes"
                        v-model="reisgosPocoFrecuentes"
                        placeholder="Escriba los riesgos frecuentes..."
                      />
                    </b-form-group>
                    <b-form-group>
                      <label
                        >Riesgos Especificos del Paciente:
                        <span class="text-danger">*</span></label
                      >
                      <b-form-textarea
                        id="v-riesgosEspecificos"
                        v-model="riesgosEspecificos"
                        placeholder="Escribir los riesgos especificos..."
                      >
                      </b-form-textarea>
                    </b-form-group>
                    <b-form-group>
                      <label
                        >Descripcion manejo posterior al procedimiento :
                        <span class="text-danger">*</span></label
                      >
                      <b-form-input
                        id="v-descripcionManejo"
                        v-model="descripcionManejo"
                        placeholder="Describa el manejo posterior..."
                      />
                    </b-form-group>
                    <b-form-group>
                      <label
                        >Alternativas procedimiento:
                        <span class="text-danger">*</span></label
                      >
                      <b-form-input
                        id="v-alternativasProcedimiento"
                        v-model="alternativasProcedimiento"
                        placeholder="Escriba alternativas de procedimiento..."
                      />
                    </b-form-group>
                    <b-form-group>
                      <label
                        >Consecuencias posibles sin procedimiento:
                        <span class="text-danger">*</span></label
                      >
                      <b-form-textarea
                        id="v-consecuencias"
                        v-model="consecuencias"
                        placeholder="Escribir los riesgos especificos..."
                      >
                      </b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
            </div>
          </template>
          <template #modal-footer="{ ok, cancel, hide }">
            <b-button variant="secondary" @click="cancel"> Cancelar </b-button>
            <b-button variant="primary" @click="ok"> Ejecutar </b-button>
          </template>
        </b-modal>
        <b-modal
          id="modal-proceso-informe"
          title="Informa Proceso"
          ok-title="Generar"
          cancel-title="Cancelar"
          @ok="informeProceso(idCirugiaMedicaProgramada)"
          size="lg"
        >
          <template #modal-title>
            <h3 class="modal-title">Informe del Proceso</h3>
          </template>
          <template #default>
            <div class="my-3"></div>

            
          </template>

          <template #modal-footer="{ ok, cancel, hide }">
            <b-button variant="secondary" @click="cancel"> Cancelar </b-button>
            <b-button variant="primary" @click="ok"> Generar </b-button>
          </template>
        </b-modal>
        <b-modal
          id="modal-cirugia-informe"
          title="Informe de Cirugia"
          ok-title="Agregar"
          cancel-title="Cancelar"
          @ok="agregarTerapia(idSolicitudTerapia)"
          size="lg"
        >
          <template #modal-title>
            <h3 class="modal-title">Informe de la Cirugía</h3>
          </template>
          <template #default>
            <div>
              <b-card bg-variant="light" text-variant="black">
                <b-card-text v-model="estadoTerapia"
                  ><b>Paciente: </b> {{ informacionCirugia.primerNombre }}
                  {{ informacionCirugia.primerApellido }}</b-card-text
                >

                <b-card-text
                  ><b>Tipo Cirugia: </b>{{ informacionCirugia.cirugia }}
                </b-card-text>
              </b-card>
              <div>
                <label>
                  <b>Código de Cirugia:</b>
                  {{ informacionCirugia.codigoCirugia }}
                </label>
              </div>
              <div>
                <label> <b>Fecha de Cirugia:</b> </label>
                <b-form-group class="mb-0">
                  <b-form-datepicker
                    v-model="fechaProgramada"
                    placeholder="Fecha de cirugia"
                  ></b-form-datepicker>
                </b-form-group>
              </div>
              <!-- <div>
                <label>Cirujano:</label>
              </div> -->
              <div class="my-3">
                <label>Procedimiento Aplicado:</label>
                <textarea
                  class="form-control"
                  v-model="procedimientoAplicado"
                ></textarea>
              </div>
              <div class="my-3">
              <label for="imagenologo">Quien realizó la cirugía?</label>
              <v-select
                id="imagenologo"
                v-model="imagenologo"
                :options="imagenologos"
                :reduce="(option) => option.value"
                label="text"
                class="d-inline-block w-100"
              />
            </div>
            <!-- {/* Aqui *\ } -->
            <div class="my-3">
              <label for="auxiliar">Auxiliar médico responsable: </label>
              <v-select
                id="auxiliar"
                v-model="auxiliar"
                :options="auxiliares"
                :reduce="(option) => option.value"
                label="text"
                class="d-inline-block w-100"
              />
            </div>
            </div>
          </template>
          <template #modal-footer="{ ok, cancel, hide }">
            <b-button variant="secondary" @click="cancel"> Cancelar </b-button>
            <b-button variant="primary" @click="ok"> Agregar </b-button>
          </template>
        </b-modal>
        <b-modal
          id="modal-consentimiento-informado"
          
          cancel-title="Cancelar"
          
          size="lg"
        >
        <ConsentimientoInformadoCirugia :idCirugia="idCirugia" /> 
          <template #modal-footer="{ cancel, hide }">
            <b-button variant="secondary" @click="cancel"> Cerrar </b-button>
          </template>
        </b-modal>
        <b-col cols="12" class="mb-2">
          <b-pagination
            v-if="items.length > 0"
            v-model="currentPageModificado"
            :total-rows="totalRows"
            :small="true"
            first-number
            last-number
            class="mb-0"
            align="center"
            prev-class="prev-item"
            next-class="next-item"
            @change="cambiarPagina"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BOverlay,
  BFormGroup,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BCardText,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormDatepicker,
  BFormTextarea,
  
  
} from "bootstrap-vue";
import _ from "lodash";
import actions from "@/assets/utils/utils";
import BCardCode from "@core/components/b-card-code";
import vSelect from "vue-select";
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import ConsentimientoInformadoCirugia from "./ConsentimientoInformadoCirugia.vue";

export default {
  components: {
    BCard,
    BCardCode,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BOverlay,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BFormDatepicker,
    BFormTextarea,
    ConsentimientoInformadoCirugia,
  },
  data() {
    return {
      pressGenerar : false,
      consultarpro: null,
      capturedImageUrl: null,
      capturedImages: [],
      size_file: 0,
      fileuploaded: "",
      importacion: false,
      bloqueo_boton: false,
      isDragging: false,
      filterOn: [],
      files: [],
      pagina_actual: 1,
      currentPage: 1,
      currentPageModificado: 1,
      establecimiento: null,
      excel_btn: null,
      pagina_actual: "",
      capturedCanvas: null,
      sortDirection: "asc",
      pdf_btn: null,
      isLoading: false,
      opsDiagnosticos: [],
      informe: null,
      esPrincipal: null,
      conclusion: null,
      especialidad: null,
      fechaEjecucion: null,
      perPage: 15,
      imagenologo: null,
      imagenologos: [],
      mostrarLoader: false,
      login_user: "",
      consultarcirugiamedicaprogramada: null,
      consultarestablecimiento: "",
      establecimientos: [],
      establecimiento: "",
      perPage: 15,
      pageOptions: [3, 5, 10],
      totalRows: 3,
      sortBy: "",
      sortDesc: false,
      diagnosticos: [],
      diagnosticosearch: null,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      informacionCirugia: {
        cirugia: "",
        codigoCirugia: "",
        primerNombre: "",
        primerApellido: "",
        fechaProgramada: "",
      },
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        {
          key: "idCirugiaMedicaProgramada",
          label: "#",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "identificacionPaciente",
          label: "Cédula",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "paciente",
          label: "Paciente",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "usuarioCreador",
          label: "Usuario",
          sortable: true,
          thClass: "text-center",
          width: "150px",
        },
        {
          key: "doctor",
          label: "Doctor",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "cirugiaMedica",
          label: "Cirugia",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "estadoCirugiaMedicaTable",
          label: "Estado",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "motivoSolicitud",
          label: "Motivo Solicitud",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "numeroOrden",
          label: "Número de Orden AS400",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "resumen",
          label: "Resumen Clínico",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "fechaCreacion",
          label: "Fecha de Emisión",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "fechaProgramada",
          label: "Fecha Programada",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "acciones",
          label: "acciones",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "informes",
          label: "informes",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      estados: [
        { value: "0", text: "Creado" },
        { value: "1", text: "Programado" },
        { value: "2", text: "Ejecutado" },
        { value: "3", text: "Resultado Final" },
      ],
      listaAcciones: [],
      token_usuario: "",
      configdateTimePicker: {
        enableTime: false,
        dateFormat: "d/m/Y",
      },
      items: [],
      descripcion: "",
      estadoCirugiaMedica: null,
      estadoCirugiaMedicaTable: null,
      fechaDesde: null,
      durestim: null,
      reisgosFrecuentes: null,
      reisgosPocoFrecuentes: null,
      riesgosEspecificos: null,
      fechaHasta: null,
      descripcionManejo: null,
      alternativasProcedimiento: null,
      consecuencias: null,
      fechaProgramadaSeleccionada: null,
      fieldsti: [
        { key: "diagnostico", label: "Descripcion", thClass: "text-center" },
        {
          key: "acciones",
          label: "acciones",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
        },
      ],
    };
  },
  created() {
    this.comprobarPermisos();
    this.fetchConsultarCirugiaMedicaProgramadas();
    this.setToken();
    this.fetchEstablecimientos();
    this.debouncedGetDiagnosticos = _.debounce(this.selDiagnostico, 300);
  },
  mounted() {
    actions.setearTitulo("Cirugias Programadas");
  },

  methods: {
    async descargarconsentimiento(idCirugia) {
      let idP = idCirugia;

      idP = idP.toString();
      
    
      const query = `
                    query MyQuery($idConsentimiento: String!) {
                consentimientoInformado(idConsentimiento: $idConsentimiento) {
                  message
                  pdfarchivo
                  status
                }
              }
            `;
      try {
       


        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: {
            idConsentimiento: idP,
          },
        });

        if (response.data.data.consentimientoInformado.status === "success") {
          if (response.data.data.consentimientoInformado) {
            console.log(response);

            const item = response.data.data.consentimientoInformado.pdfarchivo;
            actions.cargarArchivos(
              item,
              "consentimiento_" + idP + ".pdf",
              "data:application/pdf;base64"
            );
          } else {
            console.error("Error al descargar el archivo:", error);
            this.$swal({
              title: "Error",
              text: "El archivo no existe, comunicar con el adminsitrador sistema",
              icon: "error",
              confirmButtonColor: "#089599",
            });
          }
        }
      } catch (error) {
        this.$swal({
          title: "Error",
          text: "Error al descargar el archivo",
          icon: "error",
          confirmButtonColor: "#089599",
        });
      }
    },
    consentimientoInformadoCirugia(idCirugia) {
      if (idCirugia) {
        this.idCirugia = idCirugia;
        this.pressGenerar = true;
       

        this.$bvModal.show("modal-consentimiento-informado");
      }
    },
    startWebcam() {
      if (navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({ video: true })
          .then((stream) => {
            this.$refs.webcam.srcObject = stream;
          })
          .catch((error) => {
            console.log("Something went wrong!", error);
          });
      }
    },
    cirugiaMedicaAtencion(idCirugiaMedicaProgramada) {
      this.idCirugiaMedicaProgramada = idCirugiaMedicaProgramada;
      console.log("hey ejecucion", this.idCirugiaMedicaProgramada);
      this.fetchSolicitudCirugiaId(idCirugiaMedicaProgramada);
      this.$bvModal.show("modal-cirugia-ejecucion");
    },
    async selDiagnostico(search) {
      if (search) {
        const query = `
                query getDiagnosticos($search: String!) { 
                    getDiagnosticos(search: $search) {
                        id
                        descripcion
                    }
                }
                `;
        try {
          const response = await axios.post(rutas.axios + "api", {
            query,
            variables: {
              search: search,
            },
          });
          this.opsDiagnosticos = response.data.data.getDiagnosticos.map(
            (item) => ({
              value: item.id,
              text: item.descripcion,
            })
          );
        } catch (error) {
          console.error("Error fetching Diagnostico", error);
        }
      } else {
        this.opsDiagnosticos = [];
      }
    },
    removeDiagnostico(index) {
      // Elimina el diagnóstico directamente del arreglo usando `splice`
      this.diagnosticos.splice(index, 1);

      this.$store.dispatch("removeDiagnostico", index);

      // Opcionalmente, podrías mostrar un mensaje simple de que el diagnóstico ha sido eliminado
      // sin usar una alerta modal, por ejemplo, un mensaje en la interfaz de la aplicación
    },

    deleteCurrentImage() {
      this.capturedImageUrl = null; // Esto eliminará la imagen actual
    },

    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    onChange() {
      this.files = [...this.$refs.file.files];
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
    remove(i) {
      this.files.splice(i, 1);
    },
    noDiagnosticosMessage() {
      if (this.searchQuery.length <= 5) {
        return "Escribe más caracteres para buscar...";
      }
      if (this.isLoading) {
        return "Buscando diagnosticos...";
      }
      if (this.searchFailed) {
        return "Error al buscar diagnosticos. Intente de nuevo.";
      }
      if (this.filteredMedicamentos.length === 0 && !this.isLoading) {
        return "No se encontraron diagnosticos que coincidan con tu búsqueda";
      }
      return "Escribe para buscar diagnosticos...";
    },
    onSearchDiagnosticos(search, loading) {
      if (search.length > 5) {
        this.isLoading = true;
        loading(true);
        this.searchQuery = search;
        this.debouncedGetDiagnosticos(search);
      } else {
        this.opsDiagnosticos = [];
        this.isLoading = false;
      }
      loading(false);
    },
    agregarDiagnostico() {
      if (!this.diagnosticosearch || !this.diagnosticosearch.value) {
        // Asegúrate de que existe un diagnóstico seleccionado y tiene un valor (ID)
        this.$swal({
          title: "Campos Incompletos",
          text: "Por favor, seleccione un diagnóstico antes de agregar.",
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return; // No realiza la adición si no se ha seleccionado un diagnóstico
      }
      if (this.diagnosticos.length >= 3) {
        // Aquí podrías mostrar un mensaje al usuario, por ejemplo, usando alert o un snackbar
        alert("No se pueden agregar más de 3 diagnósticos.");
        return;
      }
      const nuevoDiagnostico = {
        diagnostico: this.diagnosticosearch.value, // Usa el ID del diagnóstico
        diagnosticotext: this.diagnosticosearch.text,
      };
      this.diagnosticos.push(nuevoDiagnostico);
      // Limpiar los campos después de agregar
      this.limpiarCamposDiagnostico();
      // Si estás utilizando Vuex, para actualizar el estado global
      this.$store.dispatch("addDiagnostico", nuevoDiagnostico);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
    },
    handleButtonClick(idCirugiaMedicaProgramada, estadoCirugiaMedica) {
      console.log("llegamos aqui");
      if (estadoCirugiaMedica === "1") {
        this.cirugiaMedicaAtencion(idCirugiaMedicaProgramada);
      } else {
        this.editItem(idCirugiaMedicaProgramada);
      }
    },
    esFechaHoy(fechaProgramada) {
      const hoy = new Date();
      const fechaProgramadaDate = new Date(fechaProgramada);

      // Compara solo año, mes y día
      return (
        hoy.getFullYear() === fechaProgramadaDate.getFullYear() &&
        hoy.getMonth() === fechaProgramadaDate.getMonth() &&
        hoy.getDate() === fechaProgramadaDate.getDate()
      );
    },
    cambiarPagina(pagina_actual) {
      // Actualizar currentPage con el nuevo número de página
      this.currentPage = pagina_actual;
      const establecimientoValue = this.consultarestablecimiento
        ? this.consultarestablecimiento.toString()
        : "";
      this.fetchConsultarCirugiaMedica(
        this.consultarterapiaprogramada ? this.consultarterapiaprogramada : "",
        this.currentPage,
        establecimientoValue,
        this.perPage,
        this.fechaDesde,
        this.fechaHasta,
        this.estadoCirugiaMedica
      );
    },
    async fetchEstablecimientos() {
      const query = `
                        query {
                            allEstablecimientos {
                                id
                                Descripcion
                                uniCodigo
                            }
                        }
                    `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        this.establecimientos = response.data.data.allEstablecimientos.map(
          (item) => ({
            value: item.id,
            text: item.Descripcion,
            uniCodigo: item.uniCodigo,
          })
        );
      } catch (error) {
        console.error("An error occurred while fetching the options:", error);
      }
    },

    onModalHidden() {
      // Recargar la página o actualizar los datos
      this.$router.go({ name: "consultar_cirugia_programada" });
    },

    editItem(idCirugiaMedicaProgramada) {
      // Guardar el ID para usarlo en la mutación
      this.idCirugiaMedicaProgramada = idCirugiaMedicaProgramada;
      console.log("hey", this.idCirugiaMedicaProgramada);
      // Abrir el modal
      this.$bvModal.show("modal-editar-fecha");
    },
    procesoCirugiaMedica(idCirugiaMedicaProgramada) {
      console.log("llega a proceso", idCirugiaMedicaProgramada);
      if (idCirugiaMedicaProgramada) {
        this.idCirugiaMedicaProgramada = idCirugiaMedicaProgramada;

        // Llamar a getSolicitudTerapiaId para cargar la información de la terapia
        this.fetchSolicitudCirugiaId(idCirugiaMedicaProgramada)
          .then(() => {
            this.$bvModal.show("modal-cirugia-informe");
            //console.log(this.informacionTerapia.tipoTerapia=='TERAPIA RESPIRATORIA',"JAJAJ")
            // Una vez que la información ha sido cargada, mostrar el modal
            // if(this.informacionTerapia.tipoTerapia=='TERAPIA RESPIRATORIA'){
            //     console.log(this.informacionTerapia.tipoTerapia)
            //     this.$bvModal.show('modal-terapia-informe-respiratoria');
            // }else if(this.informacionTerapia.tipoTerapia=='TERAPIA PSICOLOGICA'){
            //     console.log(this.informacionTerapia.tipoTerapia)
            //     this.$bvModal.show('modal-terapia-informe-psciologica');
            // }else{
            //     console.log(this.informacionTerapia.tipoTerapia)
            //     this.$bvModal.show('modal-terapia-informe');
            // }
          })
          .catch((error) => {
            console.error("Error al cargar información de la terapia:", error);
            // Aquí puedes manejar el error, por ejemplo, mostrando un mensaje al usuario
          });
      }
    },
    async actualizarFechaProgramada(
      idCirugiaMedicaProgramada,
      fechaProgramada
    ) {
      // Obtener la fecha actual
      const fechaActual = new Date();

      // Convertir la fecha actual a un formato que coincida con fechaProgramada
      const fechaActualFormateada = fechaActual.toISOString();

      if (fechaProgramada < fechaActualFormateada) {
        // La fecha es menor que la fecha actual, mostrar un error
        this.$swal({
          icon: "error",
          title: "Error",
          text: "La fecha no puede ser menor que la fecha actual.",
        });
        return; // Salir de la función sin realizar la solicitud al servidor
      }

      // Mostrar la alerta de confirmación
      const confirmation = await this.$swal({
        title: "¿Estás seguro de actualizar la fecha?",
        text: "No podrás deshacer esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, actualizar",
        cancelButtonText: "Cancelar",
      });

      if (confirmation.isConfirmed) {
        // El usuario confirmó la actualización, realizar la solicitud al servidor
        const mutation = `
                    mutation ActualizarFechaCirugiaMedica($idSolicitudCirugiaMedica: String!, $fechaProgramada: DateTime!) {
                        actualizarFechaProgramadaCirugiaMedica(idSolicitudCirugiaMedica: $idSolicitudCirugiaMedica, fechaProgramada: $fechaProgramada) {
                            solicitudCirugiaMedica {
                                id
                                fechaProgramada
                            }
                        }
                    }
                `;

        const variables = {
          idSolicitudCirugiaMedica: idCirugiaMedicaProgramada,
          fechaProgramada: fechaProgramada.toString(),
        };

        try {
          const response = await axios.post(rutas.axios + "api", {
            query: mutation,
            variables: variables,
          });

          if (response.data.errors) {
            // Error en el servidor backend
            this.$swal({
              icon: "error",
              title: "Error",
              text: "Hubo un error en el servidor. Por favor, inténtalo de nuevo más tarde.",
            });
          } else {
            // Actualización exitosa
            this.$swal({
              icon: "success",
              title: "Éxito",
              text: "La fecha se actualizó correctamente.",
            });

            // Realizar la recarga de la página o cualquier otra acción necesaria
            this.$router.go({ name: "consultar_cirugia_programada" });
          }
        } catch (error) {
          console.error(error);
          // Error en la solicitud HTTP
          this.$swal({
            icon: "error",
            title: "Error",
            text: "Hubo un error al actualizar la fecha. Por favor, inténtalo de nuevo.",
          });
        }
      }
    },
    async fetchSolicitudCirugiaId(idSolicitudCirugiaMedica) {
      const query = `
           query GetSolicitudCirugiamedica($idSolicitudCirugiaMedica: String!) {
                solicitudCirugiamedica(idSolicitudCirugiaMedica: $idSolicitudCirugiaMedica) {
                    status
                    message
                    solicitudCirugiaMedica {
                        id
                        fechaProgramada
                        cirugiaMedica{
                            id
                            nombre
                            codigo
                        }
                        consultamedica {
                          id
                            cita {
                                paciente {
                                    persona {
                                        primerNombre
                                        primerApellido
                                        identificacion
                                    }
                                }
                            }
                        }
                    }
                }
            }
            `;
      const variables = {
        idSolicitudCirugiaMedica: idSolicitudCirugiaMedica,
      };
      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: variables,
        });
        console.log(response);

        if (response.status === 200) {
          console.log(
            response.data.data.solicitudCirugiamedica.solicitudCirugiaMedica
              .consultamedica.cita.paciente.persona.primerNombre
          );
          this.informacionCirugia.cirugia =
            response.data.data.solicitudCirugiamedica.solicitudCirugiaMedica.cirugiaMedica.nombre;
          this.informacionCirugia.codigoCirugia =
            response.data.data.solicitudCirugiamedica.solicitudCirugiaMedica.cirugiaMedica.codigo;
          this.informacionCirugia.fechaProgramada =
            response.data.data.solicitudCirugiamedica.solicitudCirugiaMedica.fechaProgramada;
          this.informacionCirugia.id =
            response.data.data.solicitudCirugiamedica.solicitudCirugiaMedica.id;
          this.informacionCirugia.primerNombre =
            response.data.data.solicitudCirugiamedica.solicitudCirugiaMedica.consultamedica.cita.paciente.persona.primerNombre;
          this.informacionCirugia.primerApellido =
            response.data.data.solicitudCirugiamedica.solicitudCirugiaMedica.consultamedica.cita.paciente.persona.primerApellido;
        }
      } catch (error) {
        console.error("Error fetching solicitud de cirugias:", error);
        // Aquí también podrías mostrar un mensaje de error en la interfaz de usuario
      }
    },

    convertirEstadoCirugiaMedica(estadoCirugiaMedica) {
      switch (estadoCirugiaMedica) {
        case "0":
          return "Creado";
        case "1":
          return "Programado";
        case "2":
          return "Ejecutado";
        case "3":
          return "Terminado";
        default:
          return "Desconocido"; // En caso de que el estado no sea 0, 1 o 2
      }
    },

    async fetchConsultarCirugiaMedicaProgramadas(
      search = "",
      pagina_actual = 1,
      establecimiento = "",
      pageSize,
      fechaDesde = null,
      fechaHasta = null,
      estadoCirugiaMedica = null
    ) {
      const query = `
                query GetAllSolicitudesCirugiaMedica($search: String, $establecimiento: String, $fechaDesde: Date, $fechaHasta: Date, $estadoCirugiaMedica: String, $page: Int, $pageSize: Int) {
                    allSolicitudesCirugiaMedica(search: $search, establecimiento: $establecimiento, fechaDesde: $fechaDesde, fechaHasta: $fechaHasta, estadoCirugiaMedica: $estadoCirugiaMedica, page: $page, pageSize: $pageSize) {
                        total
                        status
                        message
                        solicitudes{
                            id
                            numeroOrdenAs400
                            usuarioCreador{
                                username
                            }
                            fechaCreacion
                            motivoSolicitud
                            resumenClinico
                            fechaProgramada
                            estadoCirugiaMedica
                            cirugiaMedica{
                                id
                                codigo
                                nombre
                            }
                            consultamedica{
                                cita{
                                    doctor{
                                        idPersona{
                                            primerNombre
                                            identificacion
                                            primerApellido
                                        }
                                    }
                                    paciente{
                                        id
                                        persona{
                                            primerNombre
                                            identificacion
                                            primerApellido
                                        }
                                    }
                                    establecimiento{
                                        id
                                        Descripcion
                                    }
                                }
                            }
                            
                        }
                        pageInfo {
                            currentPage
                            totalPages
                            hasNextPage
                            hasPreviousPage
                        }
                    }
                }

            `;
      const var_consulta = {
        search: search,
        establecimiento: establecimiento.toString(),
        fechaDesde: fechaDesde,
        fechaHasta: fechaHasta,
        estadoCirugiaMedica: estadoCirugiaMedica,
        page: pagina_actual,
        pageSize: pageSize,
      };
      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: var_consulta,
        });
        if (response.status === 200) {
          if (
            response.data.data.allSolicitudesCirugiaMedica.status === "Success"
          ) {
            if (response.data.data.allSolicitudesCirugiaMedica.solicitudes) {
              this.items =
                response.data.data.allSolicitudesCirugiaMedica.solicitudes.map(
                  (item) => {
                    let fechaFormateada = "";
                    if (item.fechaProgramada) {
                      const fecha = new Date(item.fechaProgramada);
                      fechaFormateada = fecha
                        .toLocaleString("es", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                        })
                        .replace(/(\d+\/)(\d+\/)(\d+),/, "$2$1$3");
                    }
                    let fechaFormateadaCreacion = "";
                    if (item.fechaCreacion) {
                      const fechaCreacion = new Date(item.fechaCreacion);
                      fechaFormateadaCreacion = fechaCreacion.toLocaleString(
                        "es",
                        {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                        }
                      );
                    }
                    return {
                      idCirugiaMedicaProgramada: item.id,
                      fechaCreacion: fechaFormateadaCreacion,
                      cirugiaMedica: item.cirugiaMedica.nombre,
                      estadoCirugiaMedica: item.estadoCirugiaMedica,
                      estadoCirugiaMedicaTable:
                        this.convertirEstadoCirugiaMedica(
                          item.estadoCirugiaMedica
                        ),
                      establecimiento:
                        item.consultamedica.cita.establecimiento.Descripcion,
                      paciente:
                        item.consultamedica.cita.paciente.persona.primerNombre +
                        " " +
                        item.consultamedica.cita.paciente.persona
                          .primerApellido, // Aquí está la combinación
                      identificacionPaciente:
                        item.consultamedica.cita.paciente.persona
                          .identificacion,
                      motivoSolicitud: item.motivoSolicitud,
                      doctor:
                        item.consultamedica.cita.doctor.idPersona.primerNombre +
                        " " +
                        item.consultamedica.cita.doctor.idPersona
                          .primerApellido,
                      numeroOrden: item.numeroOrdenAs400,
                      resumen: item.resumenClinico,
                      usuarioCreador: item.usuarioCreador
                        ? item.usuarioCreador.username
                        : "No disponible", // Modificado aquí
                      fechaProgramada: fechaFormateada,
                    };
                  }
                );

              this.totalRows =
                response.data.data.allSolicitudesCirugiaMedica.total;
              this.currentPage = 1;
              this.currentPageModificado = pagina_actual;
            } else {
              console.log("No se encontraron cirugias medicas programadas");
              // Aquí podrías establecer un mensaje en la interfaz de usuario
            }
          } else {
            console.log("Error en la respuesta del servidor");
            // Manejo del error de respuesta del servidor
          }
        }
      } catch (error) {
        console.error("Error fetching cirugias medicas programadas:", error);
        // Aquí también podrías mostrar un mensaje de error en la interfaz de usuario
      }
    },
    async ejecutarCirugiaMedica(idCirugiaMedicaProgramada) {
      this.idCirugiaMedicaProgramada = idCirugiaMedicaProgramada;
      console.log("llegamos todo ok");
      console.log(idCirugiaMedicaProgramada);
      const ejeconfirmation = await this.$swal({
        title: "¿Estás seguro de ejectuar el proceso de imagen?",
        text: "No podrás deshacer esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, actualizar",
        cancelButtonText: "Cancelar",
      });
      if (ejeconfirmation.isConfirmed) {
        const ejecutarCirugiaMedicaObjeto = {
          id_solicitud_cirugia_medica: this.idCirugiaMedicaProgramada, // Asegúrate de que este es el nombre correcto del campo esperado por el backend
          reisgos_frecuentes: this.reisgosFrecuentes,
          riesgos_especificos: this.riesgosEspecificos,
          descripcion_manejo: this.descripcionManejo,
          alternativas_procedimiento: this.alternativasProcedimiento,
          consecuencias: this.consecuencias,
          reisgos_poco_frecuentes: this.reisgosPocoFrecuentes,
          diagnosticos: this.diagnosticos, // Incluir el arreglo diagnosticos directamente
        };
        const ejecutarCirugiaMedicaString = JSON.stringify(
          ejecutarCirugiaMedicaObjeto
        );
        // El usuario confirmó la actualización, realizar la solicitud al servidor
        const mutation = `
                mutation EjecutarCirugiaMedica($datosejecutar: String!) {
                    ejecutarCirugiaMedicaMutation(datosejecutar: $datosejecutar) {
                        cirugiaMedicaEjecutada {
                            id
                            duracionEstimada
                            riesgosFrecuentes
                        }
                        message
                        status
                    }
                }

                `;

        const variables = {
          datosejecutar: ejecutarCirugiaMedicaString,
        };
        console.log(variables);

        try {
          const response = await axios.post(rutas.axios + "api", {
            query: mutation,
            variables: variables,
          });

          if (response.data.errors) {
            // Error en el servidor backend
            this.$swal({
              icon: "error",
              title: "Error",
              text: "Hubo un error en el servidor. Por favor, inténtalo de nuevo más tarde.",
            });
          } else {
            // Actualización exitosa
            this.$swal({
              icon: "success",
              title: "Éxito",
              text: "Se creó exitosamente el Consentimiento Informado del paciente.",
            });

            // Realizar la recarga de la página o cualquier otra acción necesaria
            //this.$router.go({ name: 'consultar_cirugia_programada' });
          }
        } catch (error) {
          console.error(error);
          // Error en la solicitud HTTP
          this.$swal({
            icon: "error",
            title: "Error",
            text: "Hubo un error al actualizar la fecha. Por favor, inténtalo de nuevo.",
          });
        }
      }
    },
    buscarCirugiasMedicasProgramadas() {
      const establecimientoValue = this.consultarestablecimiento
        ? this.consultarestablecimiento.toString()
        : "";
      this.fetchConsultarCirugiaMedicaProgramadas(
        this.consultarterapiaprogramada ? this.consultarterapiaprogramada : "",
        this.currentPage,
        establecimientoValue,
        15,
        this.fechaDesde,
        this.fechaHasta, // Añadir la fecha
        this.estadoCirugiaMedica // Añadir el estado
      );
    },

    viewItem(idDoc) {
      this.$router.push({
        name: "ver_doctor",
        params: { id: idDoc },
      });
    },
    removeItemid(idCirugiaMedicaProgramada) {
      const mesa = this.fetchRemoveDoctor(idCirugiaMedicaProgramada);
    },
    async fetchRemoveDoctor(idCirugiaMedicaProgramada) {
      this.$swal({
        title: "Estas seguro de eliminar Cirugia Médica?",
        text: "No seras capaz de revertir esto!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Borrar esto!",
        cancelButtonText: "No, cancelar!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          // Call the API or method to remove the item here
          try {
            const argSolCirMed = {
              id: idCirugiaMedicaProgramada,
            };
            const response = await axios.post(rutas.axios + "api", {
              query: `mutation CancelarSolicitud($id: String!) {
                                        cancelarSolicitudCirugiaMedica(solicitudDatos: { id: $id }) {
                                            status
                                            message
                                        }
                                    }`,
              variables: argSolCirMed,
            });
            if (response.status === 200) {
              if (
                response.data.data.cancelarSolicitudCirugiaMedica.status ===
                "success"
              ) {
                if (response.status === 200) {
                  this.$swal({
                    title: "Borrado!",
                    text: "Tu registro ha sido eliminado",
                    icon: "success",
                    confirmButtonColor: "#3085d6",
                  }).then((result) => {
                    // This will only run when the user presses "OK" on the "Deleted!" modal
                    if (result.isConfirmed) {
                      this.$router.go(0);
                    }
                  });
                }
                this.$router
                  .push({ name: "consultar_cirugia_programada" })
                  .catch((err) => {
                    if (err.name !== "NavigationDuplicated") {
                      console.error(err);
                    }
                  });
              } else {
                this.$swal({
                  title: "Error",
                  text: response.data.data.cancelarSolicitudCirugiaMedica
                    .message,
                  icon: "error",
                  confirmButtonColor: "#089599",
                });
              }
            }
          } catch (err) {
            console.log(err);
            return "Error al eliminar doctor";
          }
        } else {
          // User clicked the cancel button
          this.$swal({
            title: "Cancelado",
            text: "Your registro esta seguro :)",
            icon: "error",
            confirmButtonColor: "#3085d6",
          });
        }
      });
    },
    setToken() {
      const user = JSON.parse(localStorage.getItem("usuario"));
      this.login_user = user.username;
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`;
    },

    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    comprobarPermisos() {
      if (localStorage.getItem("permisos").indexOf("consultar_cirugia_programada") === -1) {
        this.$router.push({ name: "not-permitted" });
      }
    },
  },
};
</script>

<style>
.custom-modal-width {
  max-width: 500px; /* Ajusta esto a tu preferencia */
}
</style>
